import React from 'react';
import { IoMdCheckmarkCircleOutline, IoMdCloseCircleOutline } from 'react-icons/io';
import { BsClockHistory } from 'react-icons/bs';
import { AiOutlineCloseCircle } from 'react-icons/ai';
import { TbProgress } from 'react-icons/tb';
import { FaRegCheckCircle } from 'react-icons/fa';
import CheckIcon from '@rsuite/icons/legacy/Check';

export const statusStyles: {
  [key: string]: {
    bgColor: string;
    textColor: string;
    icon: React.ReactElement;
    dot: React.ReactElement;
  };
} = {
  DELIVERED: {
    bgColor: 'bg-successBg1',
    textColor: 'text-success',
    icon: <IoMdCheckmarkCircleOutline />,
    dot: <CheckIcon style={{ background: '#EEF8E6', color: '#5FB21F', borderColor: '#5FB21F' }} />,
  },
  SHIPPED: {
    bgColor: 'bg-successBg1',
    textColor: 'text-success',
    icon: <IoMdCheckmarkCircleOutline />,
    dot: <CheckIcon style={{ background: '#EEF8E6', color: '#5FB21F', borderColor: '#5FB21F' }} />,
  },
  PENDING: {
    bgColor: 'bg-neutralBg',
    textColor: 'text-neutral',
    icon: <TbProgress />,
    dot: <CheckIcon style={{ background: '#FCF5DE', color: '#E5B300', borderColor: '#E5B300' }} />,
  },
  PROCESSING: {
    bgColor: 'bg-neutralBlueBgLight',
    textColor: 'text-neutralBlueBg',
    icon: <TbProgress />,
    dot: <CheckIcon style={{ background: '#FCF5DE', color: '#E5B300', borderColor: '#E5B300' }} />,
  },
  CANCELLED: {
    bgColor: 'bg-cancelBg',
    textColor: 'text-cancel',
    icon: <AiOutlineCloseCircle />,
    dot: <CheckIcon style={{ background: '#FBE4E4', color: '#EE3434', borderColor: '#EE3434' }} />,
  },
  READY_TO_SHIP: {
    bgColor: 'bg-neutralBlueBgLight',
    textColor: 'text-neutralBlueBg',
    icon: <TbProgress />,
    dot: <CheckIcon style={{ background: '#FCF5DE', color: '#E5B300', borderColor: '#E5B300' }} />,
  },
  default: {
    bgColor: 'bg-neutralBlueBgLight',
    textColor: 'text-neutralBlueBg',
    icon: <TbProgress />,
    dot: <div className=" loading-animation max-h-[10px] max-w-[10px]" style={{ background: '#EEF8E6', color: '#5FB21F', borderColor: '#5FB21F' }} ></div>
    
  },
};
